export default function getClientWidthFirstChild(el) {
  return el && el.children[0] ? el.children[0].clientWidth : 0;
}
